<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <i class="myfont icon-rili"></i>
      <span class="font-20">校历</span>
      <p class="grey more-calendar piont-view" v-if="!canDrag&&serveId" @click="gotoCalendar">更多</p>
    
    </div>

    <el-row class="w100 tx-c" :class="h == 2 ? scrollBar1 : scrollBar" v-loading="loading">
      <!-- <el-col class="pt20 pb20 tx-c grey font-14" :span="24">暂无校历</el-col> -->
      <div class="w100 bg-w pt10 pb20 pl10 pr10 calendar-view">
        <!-- <p class="w100 mb10 tx-c grey">红色背景：休息日；灰色背景：上班日；红色圆点：事件</p> -->
        <p class="w100 tx-c font-14 ml5">
          <span v-if="semester">第{{ semester == 1 ? '一' : '二' }}学期（ </span>
          <span class="red" v-if="starttime">{{ starttime }} 至 </span>
          <span class="red" v-if="endtime">{{ endtime }} ）</span>
          <span>{{ month }}月</span>
          <span v-if="!semester">(当前年月还未设置校历)</span>
        </p>
        <!-- <span class="w15 tx-c font-14">{{ month }}月</span> -->
        <table class="w100 h100">
          <tr>
            <td class="blue" style="width: 3em">教学周</td>
            <td class="bold">一</td>
            <td class="bold">二</td>
            <td class="bold">三</td>
            <td class="bold">四</td>
            <td class="bold">五</td>
            <td class="blod red">六</td>
            <td class="blod red">日</td>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td class="font-14 blue">{{ isWeek(item.week) }}</td>
            <td class="po-r" v-for="(val, key) in item.list" :key="key" :class="itemClass(val, key)" @click="clickItem(val)">
              <div class="font-16 mc date-item">{{ isWeek(val.indexDate) }}</div>
              <div class="dian" v-if="val.items && val.items.length"></div>
            </td>
          </tr>
        </table>
      </div>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "CardCalendar",
    components: {},
    props: ["w", "h", "can-drag"],
    data() {
      return {
        baseUrl: process.env.BASE_URL,
        loading: false,
        schoolYear: "-",
        semester: 1,
        starttime: "-",
        endtime: "-",
        month: "-",
        showText: "",
        show: false,
        work: null,
        date: "-",
        list:[],
        serveId:"",
        scrollBar1:"scroll-bar1",
        scrollBar: "scroll-bar"
      };
    },
    computed: {},
    created() {},
    mounted() {
      this.fetchList();      
    },
    destroyed() {},
    methods: {
      clickItem(item) {
      if (!item.items || (item.items && item.items.length == 0)) {
        return;
      }
      let isVaca;
      switch (item.isvacation) {
        case "1":
          isVaca = "休息日";
          break;
        case "2":
          isVaca = "上班日";
          break;
        default:
          isVaca = "正常";
          break;
      }
      this.$alert(`${item.item}`, `${this.month}月${item.indexDate}日 ( 作息：${ isVaca} )`, {center: 'true',
          confirmButtonText: '确定'})
    },
    fetchList() {
      this.loading = true;
      this.$http
        .post("/calendar/list")
        .then(({ data }) => {
          if (data.resCode == 0) {
            // this.list = data.resData;
            this.schoolYear = data.resData.schoolYear;
            this.semester = data.resData.semester;
            this.starttime = data.resData.starttime;
            this.endtime = data.resData.endtime;
            this.month = data.resData.month;
            this.showText = data.resData.show;
            this.list = data.resData.data;
            this.serveId = data.resData.serveId
            this.checkBox = [];
            this.items = null;
            
            // 如果默认当前月份没设置校历的时候，处理默认月份
            if (!this.monthList) {
              let arr = [];
              let myData = new Date();
              let month = myData.getMonth() < 10 ? "0" + (myData.getMonth() + 1) : (myData.getMonth() + 1);
              this.month = myData.getFullYear() + "-" + month;
              this.schoolYear = myData.getFullYear();
              
              arr.push({ label: month + "月", value: this.month });
              this.monthList = arr;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 是否教学周
    isWeek(str) {
      if (typeof str == "string" && str.indexOf("not") > -1) {
        return "-";
      } else {
        return str;
      }
    },
    itemClass(val, key) {
      let str = " ";
      // 字体颜色
      if (!val.month) {
        str += "grey ";
      } else {
        if (!val.jobDate) {
          str += "grey ";
        } else {
          if (key == 5 || key == 6) {
            str += "red ";
          }
        }
      }

      // 背景色
      // if (!val.jobDate) {
      //   str += "bg-g ";
      // }
      if (val.isvacation == "1") {
        str += "bg-red ";
      } else if (val.isvacation == "2") {
        str += "bg-g ";
      }
      return str;
    },
    gotoCalendar(){
      this.$router.push(`serveSearch/${this.serveId}/Calendar`)
    }
    },
    watch: {},
    filters: {
      workType(value) {
      switch (value) {
        case "1":
          return "休息日";
        case "2":
          return "上班日";
        default:
          return "正常";
      }
    }
    }
  };
</script>

<style scoped>
  .card-title {
    height: 40px;
  }

  .card-title i {
    color: #619df8;
    font-size: 20px;
    margin-left: 10px;
    margin-right: 5px;
  }

.calendar-view table {
  border-collapse: collapse;
}

.calendar-view table td {
  padding: 5px 0;
  height: 42px;
  text-align: center;
  /* border: 1px solid #ddd; */
}

.date-item {
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
}

.bg-red .date-item {
  /* color: #fff; */
  background: #fdf0f0;
}

.bg-g .date-item {
  /* color: #fff; */
  background: #f5f5f5;
}

.dian {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 1em 0 0 -2px;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: #ed5440;
}

.dian-d {
  width: 4px;
  height: 4px;
  border-radius: 2px;
}

.piont-view:hover{
  cursor: pointer;
}

.more-calendar{
  position: absolute;
  right: 10px;
}

.scroll-bar{
  height: 308px;
  overflow-y: auto;
}

.scroll-bar1{
  height: 608px;
  overflow-y: auto;
}
</style>